export default {
    namespaced: true,
    state: {
        timeLineShow: false,
        timesData: null
    },
    mutations: {
        setTimeLineShow(state, flag) {
            state.timeLineShow = flag
        },
        setTimesData(state, data) {
            state.timesData = data
        }
    }
}